export default {"src":"/_next/static/media/Gyncology.5d3992ce.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};